import React, { useEffect, useState } from 'react';
import { Route, Navigate } from 'react-router-dom';
import useAuth  from '../../hooks/useAuth';
import { JSX } from 'react/jsx-runtime';
import Mobile from '../../components/Mobile/Mobile';
/**
 * 
 * @param param0 - The component to render if the user is authenticated, and the rest of the route props.
 * @param param0.component - The component to render if the user is authenticated.
 * @returns 
 * A React component that renders a private route. If the user is authenticated, it renders the specified component or a mobile version if on a mobile device. If not authenticated, it redirects to the login page.
 * @example
 * <PrivateRoute component={Dashboard} path="/dashboard" />   
 * This component checks if the user is authenticated and whether they are on a mobile device. If authenticated, it renders the specified component; otherwise, it redirects to the login page. It also listens for window resize events to update the mobile state.
 * @see {@link useAuth} for authentication logic.
 * @see {@link Mobile} for the mobile component.
 * @see {@link Route} for routing logic.
 * @see {@link Navigate} for redirection logic.
 * @see {@link useState} and {@link useEffect} for state management and side effects.
 * 
 */

const PrivateRoute = ({ component: Component, ...props }: any) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768 ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    console.log("Adding resize listener...");
    const handleResize = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
      console.log("isMobile updated to:", isMobile);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      console.log("Removing resize listener...");
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Instead of using `<Route>`, return the actual components.
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return isMobile ? <Mobile {...props} /> : <Component {...props} />;
};

export default PrivateRoute;
